import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HotArticlesSection from './components/HotArticlesSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    document.title = 'JM Comic – 官方入口与完整使用指南 | 漫画阅读平台';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'JM Comic 是广受欢迎的漫画阅读平台，提供海量正版与同人漫画资源。访问方式、注册流程、分类导航、会员权益及常见问题详解，助您快速上手畅享优质漫画。'
      );
    }
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'JM Comic',
    url: window.location.origin,
    description:
      'JM Comic 官方入口与完整使用指南，涵盖注册教程、分类导航、会员权益及常见问题。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${window.location.origin}/categories?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <HeroSection />
      <FeaturesSection />
      <HotArticlesSection />
      <FAQSection />
    </>
  );
}